<template>
  <headboard></headboard>
  <div class="" style="padding-left:5%;padding-right:5%;">
    <div class="row">
      <div class="col-sm-8 text-center">

        <div class="row justify-content-center">
          <div class="col-lg-10 col-md-5 d-flex flex-column align-items-center justify-content-center">
            <div class="row">
              <div class="col-sm-12">
                <img src="@/assets/images/logo.png" alt="" class="imgstar" style="width:70%">
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-sm-12 text-center">
                <p>Lodge assessment jobs, upload relevant documents, access instant prices and download reports via our online client hub.</p>
              </div>
            </div>
          </div>
        </div>



      </div>

      <div class="col-sm-4">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-md-8 d-flex flex-column align-items-center justify-content-center">

            <div class="card mb-3 mt-5">
              <div class="card-body">
                <div v-if="type=='login'">
                  <log_in @logged="gotUser($event)" @notclient="sendToRegister" />
                  
                </div>
                <div v-if="type=='register'">
                  <new_client @notregister="sendToLogin" @registered="gotUser($event)" />
                  
                </div>
                
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>

  </div>

  <forgot_client />
</template>
<script>
import header from "../components/header.vue"
import log_in from "../../components/global/log-in.vue"
import new_client from "../../components/global/new-client.vue"
import forgot_client from "../../components/global/forgot-client.vue"

export default {
  name: 'login-page',
  data: function () {
    return {
      type: "login",
    }
  },
  components: {
    'headboard': header,
    'log_in': log_in,
    'new_client': new_client,
    'forgot_client':forgot_client
  },
  methods: {
    gotUser(usr) {
      let direction = "";

      if (usr.isAdmin) {
        direction = "/administration";
      }
      else {
        direction = "/user";
      }

      window.location.href = this.$vtc.getConfig().getHomeUrl() + direction;
    },
    sendToRegister(){
      this.type="register";
    },
    sendToLogin(){
      this.type="login";
    }
  }
}
</script>
<style></style>